import _ from 'underscore';
import $ from 'jquery';
import { View } from 'backbone';
import messages from 'messages';
import Settings from './settings_model';

const BaseComponent = View.extend({
    name: 'base',
    template: () => '<span>Your need extend base component</span>',
    bound: false,
    initialize(options = {}) {
        this.cId = options.id;
        this.uId = options.uId || '';
        this.data = options;
        this.$parent = this.$el.parents('#js-view');
        this.$root = this.$parent;
        this.render();
    },
    bindParent() {
        this.$parent.on('component:all:error', _.bind(this.onParentError, this));
        this.$parent.on('component:all:error:clear', _.bind(this.onClearErrors, this));
    },
    onParentError: () => {},
    onClearErrors: () => {},
    routeByUrl(url) {
        window.location.href = url;
    },
    click(event) {
        this.components.proxyEvent('click', event, this);
    },
    keyup(event) {
        this.components.proxyEvent('keyup', event, this);
    },
    change(event) {
        this.components.proxyEvent('change', event, this);
    },
    submit(event) {
        this.components.proxyEvent('submit', event, this);
        return false;
    },
    error(event) {
        this.components.proxyEvent('error', event, this);
    },
    render() {
        const parent = {
            'parent-uId': this.uId || '',
            'parent-name': this.name || '',
        };
        const context = _.extend({ msgs: messages }, Settings.get(), this.data, parent);
        const rendered = this.template(context);
        if (this.data.replace) {
            this.replace($(rendered));
        } else {
            this.$el.html(rendered);
        }
        return rendered;
    },
    replace($rendered) {
        this.$el.replaceWith($rendered);
        this.$el = $rendered;
        [this.el] = $rendered;
        return $rendered;
    },
    // backward compatibility
    components: {
        proxyEvent(type, event, component) {
            const { $el } = component;
            const cId = `:${component.cId}`;
            const name = `${component.name}:`;
            const params = [event, component];
            const prefix = 'component:';

            if (cId) {
                this.triggerEvent($el, `${prefix}${name}${type}${cId}`, event, params);
            }
            this.triggerEvent($el, `${prefix}${name}${type}`, event, params);
            this.triggerEvent($el, `${prefix}${name}all`, event, params);
            this.triggerEvent($el, `${prefix}all:${type}`, event, params);
            this.triggerEvent($el, `${prefix}all:all`, event, params);
        },
        triggerEvent($el, type, original, params) {
            const event = _.extend({}, original, {
                type,
                extra: params,
            });

            $el.trigger(event, params);
        },
    },
});

export default BaseComponent;
